import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FiArrowLeft, FiClock, FiUser, FiTag, FiEye, FiCalendar } from 'react-icons/fi';
import { publicAPI } from '../services/api';
import { generateImageUrl, formatDate } from '../utils/helpers';
import LoadingSpinner from '../components/common/LoadingSpinner';
import './BlogDetail.css';

const BlogDetail = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    publicAPI.getBlogBySlug(slug)
      .then(res => {
        if (res.success) {
          setBlog(res.data);
          publicAPI.incrementBlogView(res.data.id).catch(() => {});
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <LoadingSpinner />;
  if (!blog) return <div className="container"><h2>Blog not found</h2></div>;

  return (
    <article className="section blog-detail-page">
      <Helmet>
        <title>{blog.seoTitle || blog.title} | Deepak Chauhan</title>
        <meta name="description" content={blog.seoDescription || blog.excerpt} />
        <meta name="keywords" content={blog.seoKeywords || blog.tags} />
        <meta property="og:title" content={blog.title} />
        <meta property="og:description" content={blog.excerpt} />
        {blog.featuredImageUrl && <meta property="og:image" content={generateImageUrl(blog.featuredImageUrl)} />}
      </Helmet>

      <div className="container">
        <Link to="/blog" className="back-link"><FiArrowLeft /> Back to Blog</Link>

        <div className="blog-detail-header">
          <span className="blog-detail-category">{blog.category}</span>
          <h1>{blog.title}</h1>
          <div className="blog-detail-meta">
            <span><FiCalendar /> {formatDate(blog.publishedDate || blog.createdAt)}</span>
            <span><FiEye /> {blog.viewCount} views</span>
          </div>
        </div>

        {blog.featuredImageUrl && (
          <div className="blog-detail-image">
            <img src={generateImageUrl(blog.featuredImageUrl)} alt={blog.title} />
          </div>
        )}

        <div className="blog-detail-content" dangerouslySetInnerHTML={{ __html: blog.content }} />

        {blog.tags && (
          <div className="blog-detail-tags">
            <FiTag />
            {blog.tags.split(',').map(t => (
              <span key={t} className="blog-tag">{t.trim()}</span>
            ))}
          </div>
        )}
      </div>
    </article>
  );
};

export default BlogDetail;
